import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  title?: ReactNode;
  actions?: ReactNode;
  noPadding?: boolean;
}

export function Card({ children, className = '', title, actions, noPadding = false }: CardProps) {
  return (
    <div className={`bg-white rounded-xl border border-slate-200 ${className}`}>
      {(title || actions) && (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-3 px-4 py-3 border-b border-slate-100">
          {title && (
            <h3 className="text-[15px] font-semibold text-slate-900 tracking-tight">{title}</h3>
          )}
          {actions && <div className="flex gap-2 w-full sm:w-auto">{actions}</div>}
        </div>
      )}
      <div className={noPadding ? '' : 'p-4'}>{children}</div>
    </div>
  );
}

export default Card;
